import * as React from "react";

import { ComponentType } from "./Chapters";

export default ({ key, method, storeName }) => {
  switch (key) {
    default:
      return <ComponentType method={method} storeName={storeName} />;
  }
};
